module.exports = __webpack_public_path__ + "static/media/back.a5d3db11.jpg";